var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseInfoButton',{attrs:{"identifier":_vm.page.id,"viewmodel":_vm.page,"extraClasses":['page']},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var url = ref.url;
return [_c('a',{attrs:{"href":url,"target":"_blank"}},[_vm._v("page")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }